import React from 'react';
import PDF from './img/pdf.svg';
import XLSX from './img/xls.svg';
import DOCX from './img/docx.svg';
import './Format.scss';

const FormatList = ({type, active, onClick}) => {

    const returnFormatImage = (type) => {
        let imgSrc = '/images/doc.svg';
        
        switch (type) {
            case 'PDF':
                imgSrc = PDF;
                break;
            case 'DOCX':
                imgSrc = DOCX;
                break;
            case 'XLSX' :
                imgSrc = XLSX;
                break;
            default:
                break;
        }
        return <img src={imgSrc} alt={type}/>
    };

    return (
        <div className={`reports-format-item ${(active ? 'active' : '')}`}
             onClick={() => onClick()}>
            {returnFormatImage(type)}
        </div>
    )
};

export default FormatList;